export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.58 2.5c1.959 0 3.255 1.775 2.962 3.501A4 4 0 0122.5 10v8a4 4 0 01-4 4h-13a4 4 0 01-4-4v-8a4 4 0 014-4h.117c-.29-1.72.998-3.5 2.963-3.5h7zM5.5 8a2 2 0 00-2 2v8a2 2 0 002 2h.98l4.528-6.47L6.723 8H5.5zm7.56 6.087L8.92 20h9.58a2 2 0 002-2v-8a2 2 0 00-2-2h-1.027l-4.413 6.087zM8.58 4.5a1 1 0 00-.79 1.612l4.433 5.721 4.167-5.746a1 1 0 00-.81-1.587h-7z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};